export default function Promises() {
  const promises = [
    {
      icon: "ri-footprint-fill",
      title: "スリッパ持参・徹底養生",
      description: "お客様の大切なお家を汚さないよう、スリッパを持参し、工事エリアは完全養生。床や壁を傷つけない細心の注意を払います。",
      image: "https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/28d4ca8f5a90fc57f75d6f07dc019a1c.png"
    },
    {
      icon: "ri-brush-fill",
      title: "掃除機＆周辺清掃",
      description: "工事後は必ず掃除機をかけ、周辺も清掃。「来る前よりキレイになった」と言っていただけることが、湧水堂の誇りです。",
      image: "https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/944f0f553d6aad344ac83314d10a0a2b.jpeg"
    },
    {
      icon: "ri-line-fill",
      title: "LINE24時間対応",
      description: "工事中の不安や疑問は、夜でも休日でもLINEで即対応。「安心を止めない」ことが、湧水堂の使命です。",
      image: "https://public.readdy.ai/ai/img_res/24f9530439b2a75ef1f454316c12b177.jpg"
    },
    {
      icon: "ri-time-fill",
      title: "+5分の気配り",
      description: "工事完了後＋５分で周辺の清掃やお客様の小さなお悩み事にも対応。この「プラスアルファ」が、小さな感動を生み出します。",
      image: "https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/14bc908d00e5efebfff065e0c7700a46.jpeg"
    },
    {
      icon: "ri-mail-send-fill",
      title: "手書きサンキューカード",
      description: "工事完了後、担当者から手書きのお礼状をお送りします。デジタル時代だからこそ、温かい「残り韻」を大切にしています。",
      image: "https://readdy.ai/api/search-image?query=Handwritten%20thank%20you%20card%20with%20heartfelt%20message%20and%20personal%20signature%2C%20elegant%20stationery%2C%20warm%20personal%20touch%2C%20Japanese%20calligraphy%20style%2C%20professional%20yet%20personal%20communication%2C%20gratitude%20expression&width=800&height=600&seq=promises5&orientation=landscape"
    },
    {
      icon: "ri-graduation-cap-fill",
      title: "年4回の接遇研修",
      description: "技術だけでなく、マナーや言葉遣いも磨き続けています。「職人の人柄」も、湧水堂の商品です。",
      image: "https://readdy.ai/api/search-image?query=Professional%20training%20session%20with%20renovation%20workers%20learning%20customer%20service%20skills%20and%20hospitality%2C%20instructor%20teaching%20communication%20techniques%2C%20bright%20training%20room%2C%20team%20learning%20together%2C%20professional%20development%20atmosphere&width=800&height=600&seq=promises6&orientation=landscape"
    },
    {
      icon: "ri-feedback-fill",
      title: "Google★4.7の即時改善",
      description: "お客様の声は、すぐに現場へフィードバック。良い評価も厳しいご意見も、すべてが湧水堂を成長させる糧です。",
      image: "https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/64b36c41b463e70f2f5d62cb69762052.png"
    }
  ];

  return (
    <section id="promises" className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-block bg-[#ff8c42]/10 px-4 sm:px-6 py-2 rounded-full mb-4 sm:mb-6">
            <span className="text-[#ff8c42] font-bold text-sm sm:text-base">湧水堂の公約</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a2b4a] mb-4 sm:mb-6 px-2">
            ホスピタリティ<br className="sm:hidden" />「7つの約束」
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto px-4">
            技術と価格は、プロとして当たり前。<br />
            湧水堂は、工事中もその後も「安心」を公約するパートナーです。
          </p>
        </div>

        {/* Promises Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-10">
          {promises.map((promise, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl sm:rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              {/* Image */}
              <div className="w-full h-48 sm:h-56 lg:h-64 overflow-hidden">
                <img 
                  src={promise.image}
                  alt={promise.title}
                  className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-6 sm:p-8">
                <div className="flex items-start gap-3 sm:gap-4 mb-3 sm:mb-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#ff8c42]/10 rounded-xl flex-shrink-0">
                    <i className={`${promise.icon} text-[#ff8c42] text-xl sm:text-2xl`}></i>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-[#1a2b4a] leading-tight">
                    {promise.title}
                  </h3>
                </div>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                  {promise.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Message */}
        <div className="mt-12 sm:mt-16 text-center">
          <div className="inline-block bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 shadow-xl max-w-4xl">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#ff8c42]/10 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
              <i className="ri-heart-fill text-[#ff8c42] text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#1a2b4a] mb-3 sm:mb-4 px-2">
              なぜ、ここまでやるのか？
            </h3>
            <p className="text-sm sm:text-base lg:text-lg text-gray-600 leading-relaxed px-2">
              それは、湧水堂が目指すのが「一度きりの取引」ではなく、<br className="hidden sm:inline" />
              <strong className="text-[#ff8c42]">「一生付き合えるパートナー」</strong>だからです。<br />
              船橋市の皆様に、何かあったときに真っ先に思い出していただける。<br className="hidden sm:inline" />
              そんな存在でありたいと、心から願っています。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
